export const OTHER_RELIGION = 17;
export const CIVIL_STAT_MARRIED = 19;
export const DATE_FORMAT = 'YYYY-MM-DD';
export const OTHER_OWNERSHIP_TYPE = 50;
export const TENANT_OWNERSHIP_TYPE = 48;
export const LEASE_OWNERSHIP_TYPE = 49;
export const OTHER_OWNERSHIP_DOC = 63;

export const ANIMAL_TYPE_CARABAO = 10;
export const ANIMAL_TYPE_CATTLE = 11;
export const ANIMAL_TYPE_GOAT = 12;
export const ANIMAL_TYPE_SHEEP = 13;
export const ANIMAL_TYPE_SWINE = 14;


export const MODULE_DASHBOARD = 5;
export const MODULE_DA_ANIMAL_INV = 6;
export const MODULE_DA_CATTLE = 7;
export const MODULE_DA_GOAT = 8;
export const MODULE_DA_SHEEP = 9;
export const MODULE_REG_ANIMALS = 10;
export const MODULE_REG_CATTLE = 11;
export const MODULE_REG_GOAT = 12;
export const MODULE_REG_SHEEP = 13;
export const MODULE_BREEDING_EVENT = 14;
export const MODULE_ACCOUNT = 15;
export const MODULE_ACCT_FARM = 16;
export const MODULE_ACCT_EMPLOYEE = 17;
export const MODULE_SETTINGS = 18;
export const MODULE_PARAMETERS = 19;
export const MODULE_ACCESS_MANAGEMENT = 20;
export const MODULE_USERS = 21;
export const MODULE_MANAGE_MODULES = 22;